import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./i18n/AuthContext";
import Landing from "./pages/Landing";
import Portal from "./pages/Portal";
import Register from "./pages/Register";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Legal from "./pages/Legal";
import CookieBanner from "./components/CookieBanner";
import ChatWidget from "./components/ChatWidget";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/portal" element={<Portal />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/impressum" element={<Legal type="impressum" />} />
              <Route path="/datenschutz" element={<Legal type="datenschutz" />} />
              <Route path="/agb" element={<Legal type="agb" />} />
              <Route path="/einlagensicherung" element={<Legal type="einlagensicherung" />} />
              <Route path="/cookies" element={<Legal type="cookies" />} />
            </Routes>
            <CookieBanner />
            <ChatWidget />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
